// 直播间状态
export const PLAY_STATUS = {
    UNKNOWN: -1,
    // 未知状态
    LIVE_NOTSTRAT: 1,
    // 未开始状态
    LIVE_DOING: 2,
    // 直播中
    LIVE_FINISH: 3,
    // 直播结束
    LIVE_SUSPEND: 4,
    // 直播暂停
    LIVE_OVERDUE: 5,
    // 直播已过期
    LIVE_ERROR: 6 // 直播出错
};
export var LiveClearity;
(function (LiveClearity) {
    LiveClearity[LiveClearity["origin"] = 1] = "origin";
    // 超清
    LiveClearity[LiveClearity["HD"] = 2] = "HD";
    // 高清
    LiveClearity[LiveClearity["SD"] = 3] = "SD";
    // 标清
    LiveClearity[LiveClearity["LD"] = 4] = "LD"; // 流畅
})(LiveClearity || (LiveClearity = {}));
export var QueryGoal;
(function (QueryGoal) {
    QueryGoal[QueryGoal["LIVE_INFO"] = 1] = "LIVE_INFO";
    // 直播信息
    QueryGoal[QueryGoal["LIVE_RESERVE"] = 2] = "LIVE_RESERVE"; // 预约直播
})(QueryGoal || (QueryGoal = {}));
export const ReserveTipWay = {
    TOAST: 'toast',
    MODAL: 'modal'
};
export const PLATFROM_ID = {
    MT: 2,
    DP: 1
};
export const APPID_TYPE = {
    MT: 10,
    DP: 1
};
export const PLATFORM_TYPE = {
    MT: 'MT',
    DP: 'DP'
};
export const LIVE_DOING_IMAGE = 'https://p0.meituan.net/ingee/5b831444d04090d927ee0bf5061c41212055.png';
export const RIGHT_ARROW = 'https://p0.meituan.net/ingee/933ee2fe0ec4d11fc67d2a022c5932af242.png';
export const MODAL_CLOSE_IMAGE = 'https://p0.meituan.net/ingee/03aa2168d14891b903667b4401e9101f2593.png';
export const LIVE_FINISH_DASH_LINE_FRONT = 'https://p0.meituan.net/ingee/c5235089710f8c94e02d52665159c347296.png';
export const LIVE_FINISH_DASH_LINE_END = 'https://p0.meituan.net/ingee/5bbae6d4fe7a6f45aaa7d99dc9934f94262.png';
